import MasterPage, { nameColumn, UsageCount } from "./MasterPage";
import { SubscriptionPlan } from "../../types";
import { DURATION_TYPES } from "../../constants/enums";
import { formatDuration } from "../../utils/format";
import Badge from "../../components/ui/Badge";

export default function SubscriptionPlansPage() {
    return (
        <MasterPage<SubscriptionPlan>
            title="Subscription Plans"
            subtitle="Billing periods for software. The renewal date is calculated from the plan length."
            endpoint="/subscription-plan"
            singular="plan"
            emptyForm={{ name: "", duration: "1", durationType: "YEAR" }}
            toForm={(r) => ({ name: r.name, duration: String(r.duration), durationType: r.durationType })}
            toPayload={(f) => ({ name: f.name, duration: Number(f.duration), durationType: f.durationType })}
            usage={(r) => r._count?.customerProducts ?? 0}
            fields={[
                { name: "name", label: "Name", kind: "text", required: true, placeholder: "e.g. 1 Year" },
                { name: "duration", label: "Duration", kind: "number", required: true, min: 1, max: 3650, half: true },
                { name: "durationType", label: "Unit", kind: "select", required: true, options: DURATION_TYPES, half: true },
            ]}
            columns={[
                nameColumn<SubscriptionPlan>(),
                { key: "length", header: "Length", render: (r) => <Badge tone="violet">{formatDuration(r.duration, r.durationType)}</Badge> },
                { key: "usage", header: "Subscribers", render: (r) => <UsageCount count={r._count?.customerProducts} /> },
            ]}
        />
    );
}